const initialState = {
  fields: []
};
const fieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FIELD_DATA':
      return {
        ...state,
        fields: action.payload
      };
    default:
      return state;
  }
};

export default fieldReducer;
